import { Component, OnInit, inject } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { NavbarComponent } from './layout/navbar/navbar.component'
import { environment } from '../environments/environment'
import { ProductAdoptionService } from '@everyday-speech/eds-design-system-lib'
import { LocalUserService } from './common/services/local-user.service'
import { ObservabilityService } from './common/services/observability.service'
import { FeatureFlaggingService } from './common/services/feature-flagging/feature-flagging.service'
import packageJson from '../../package.json'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  /** Routes that render their own full-page chrome (no top nav bar). */
  private static readonly CHROMELESS_ROUTES = ['/login', '/auth/callback']

  private readonly localUserService = inject(LocalUserService)
  private readonly productAdoptionService = inject(ProductAdoptionService)
  private readonly observabilityService = inject(ObservabilityService)
  private readonly featureFlaggingService = inject(FeatureFlaggingService)
  private readonly router = inject(Router)

  protected get showNavbar(): boolean {
    const url = this.router.url.split('?')[0].split('#')[0]
    return !AppComponent.CHROMELESS_ROUTES.some(route => url === route || url.startsWith(`${route}/`))
  }

  ngOnInit(): void {
    this.initializeObservability()
    this.initializeFeatureFlags()
    this.servicesInitializer()
  }

  private async initializeObservability(): Promise<void> {
    await this.observabilityService.initializeAll(packageJson.version)
  }

  private async initializeFeatureFlags(): Promise<void> {
    try {
      await this.featureFlaggingService.init()
    } catch (error) {
      console.error('❌ Failed to initialize Feature Flagging Service:', error)
    }
  }

  // TO DO: This part should be reimplemented in the future, once admin portal v2 has it's own login page
  // Task: https://app.asana.com/0/1207954996578868/1209248340109313/f
  servicesInitializer(): void {
    this.localUserService.activeUser$.subscribe(user => {
      if (user) {
        this.productAdoptionService.initialize(environment.userpilotToken)
        this.productAdoptionService.identifyUser(user.userId, {
          email: user?.email,
          accessRole: user?.accessRole,
          belongsToActivePilot: user?.belongsToActivePilot,
          firstName: user?.firstName,
          lastName: user?.lastName,
          professionalRole: user?.professionalRole,
          status: user?.status,
          adminPortalVersion: 'v2',
          daysActive: user?.daysActive,
          license: user?.license?.title,
        })

        // Identify user for feature flagging when they log in
        this.featureFlaggingService.identifyUser({
          id: user.userId,
          email: user.email ?? undefined,
          accessRole: user.accessRole ?? undefined,
          belongsToActivePilot: user.belongsToActivePilot ?? undefined,
          firstName: user.firstName ?? undefined,
          lastName: user.lastName ?? undefined,
          professionalRole: user.professionalRole ?? undefined,
          status: user.status ?? undefined,
          daysActive: user.daysActive ?? undefined,
          license: user.license?.title ?? undefined,
          adminPortalVersion: 'v2',
        })
      }
    })
  }
}
